export const PATIENT_NUMBER_FIELD = 'patientNumber';

export const PORTAL_TURN_RETRY_MESSAGE =
  'No pudimos registrar el turno. Actualizá la página e intentá de nuevo.';

function isDeniedMessage(message) {
  return message === 'Acceso denegado.' || message === 'Acceso denegado';
}

export function patientFacingTurnError(response, fallback) {
  const message = response?.message;
  if (response?.code === 403 || isDeniedMessage(message)) {
    return PORTAL_TURN_RETRY_MESSAGE;
  }
  return message || fallback;
}

export async function collectTurnSecurity({
  patientNumber,
  executeRecaptcha,
  action,
}) {
  let recaptchaToken = null;
  if (typeof executeRecaptcha === 'function') {
    try {
      recaptchaToken = await executeRecaptcha(action);
      if (process.env.NODE_ENV !== 'production') {
        console.log('[reCAPTCHA] challenge', {
          action,
          ok: Boolean(recaptchaToken),
        });
      }
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[reCAPTCHA] error al ejecutar challenge', err);
      }
      return {
        blocked: true,
        message: 'No se pudo verificar la solicitud. Intentá de nuevo.',
      };
    }
  } else if (process.env.NODE_ENV === 'production') {
    return {
      blocked: true,
      message: 'No se pudo verificar la solicitud. Intentá de nuevo.',
    };
  }

  return {
    blocked: false,
    recaptchaToken,
    [PATIENT_NUMBER_FIELD]: patientNumber || '',
  };
}

export function withTurnSecurity(payload, security) {
  return {
    ...payload,
    recaptchaToken: security.recaptchaToken,
    [PATIENT_NUMBER_FIELD]: security[PATIENT_NUMBER_FIELD] || '',
  };
}

export async function runTurnWithCaptchaRetry({
  patientNumber,
  executeRecaptcha,
  action,
  send,
}) {
  const attempt = async () => {
    const security = await collectTurnSecurity({
      patientNumber,
      executeRecaptcha,
      action,
    });
    if (security.blocked) {
      return { blocked: true, message: security.message, response: null };
    }
    const response = await send(security);
    return { blocked: false, message: null, response };
  };

  let result = await attempt();
  if (!result.blocked && result.response?.captchaRetry === true) {
    result = await attempt();
  }
  return result;
}
